var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "visitor-check" }, [
    _c("div", { staticClass: "fl-container" }, [
      _c("p", { staticStyle: { margin: "20px 0" } }, [
        _c(
          "b",
          {
            staticStyle: {
              cursor: "pointer",
              "font-size": "16px",
              "border-bottom": "2px dashed #333",
              "font-weight": "500",
            },
            on: {
              click: function ($event) {
                _vm.showDescr = !_vm.showDescr
              },
            },
          },
          [_vm._v("Описание")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "uk-icon-question-circle",
          staticStyle: {
            "vertical-align": "top",
            "font-size": "0.8rem",
            "padding-left": "7px",
          },
        }),
      ]),
      _vm._v(" "),
      _vm.showDescr
        ? _c(
            "p",
            {
              staticStyle: {
                "font-size": "16px",
                "font-weight": "400",
                margin: "20px 0",
                "max-width": "960px",
                padding: "20px",
                background: "#eee",
                border: "1px solid lightgray",
                "border-radius": "5px",
              },
            },
            [
              _c("b", [
                _vm._v("Среднее время проверки составляет от 10 до 15 секунд."),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n            Сформированный отчет будет загружен в виде файла в вашем браузере.\n            "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                '\n            Регламентированная проверка, позволяющая оперативно, в течение нескольких секунд, сходу отсечь наиболее проблемных "персонажей" ‑ террористов/экстремистов, лиц находящихся в розыске, предоставивших некорректные паспортные данные.\n            '
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Типовые примеры использования:")]),
              _vm._v(" "),
              _vm._m(0),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "visitor-check-block checkbox-container" }, [
        _c("div", { staticClass: "mobile-group" }, [
          _c("div", { staticClass: "form-group form-group_checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkbox.passports,
                  expression: "checkbox.passports",
                },
              ],
              attrs: { type: "checkbox", id: "checkbox-ned-pasp" },
              domProps: {
                checked: Array.isArray(_vm.checkbox.passports)
                  ? _vm._i(_vm.checkbox.passports, null) > -1
                  : _vm.checkbox.passports,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.checkbox.passports,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.checkbox, "passports", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.checkbox,
                          "passports",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.checkbox, "passports", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-group__header",
                attrs: {
                  for: "checkbox-ned-pasp",
                  title:
                    "проверка осуществляется только по серии и номеру паспорта",
                },
              },
              [_vm._v("Реестр недействительных паспортов ГУВМ МВД России")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group form-group_checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkbox.terrorists,
                  expression: "checkbox.terrorists",
                },
              ],
              attrs: { type: "checkbox", id: "checkbox-ter" },
              domProps: {
                checked: Array.isArray(_vm.checkbox.terrorists)
                  ? _vm._i(_vm.checkbox.terrorists, null) > -1
                  : _vm.checkbox.terrorists,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.checkbox.terrorists,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.checkbox, "terrorists", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.checkbox,
                          "terrorists",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.checkbox, "terrorists", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-group__header",
                attrs: { for: "checkbox-ter" },
              },
              [_vm._v("Реестр террористов/экстремистов Росфинмониторинг")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-group " }, [
          _c("div", { staticClass: "form-group form-group_checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checkbox.rozisk,
                  expression: "checkbox.rozisk",
                },
              ],
              attrs: { type: "checkbox", id: "checkbox-fed" },
              domProps: {
                checked: Array.isArray(_vm.checkbox.rozisk)
                  ? _vm._i(_vm.checkbox.rozisk, null) > -1
                  : _vm.checkbox.rozisk,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.checkbox.rozisk,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.checkbox, "rozisk", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.checkbox,
                          "rozisk",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.checkbox, "rozisk", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-group__header",
                attrs: { for: "checkbox-fed" },
              },
              [_vm._v("Реестр федерального розыска МВД РФ")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group form-group_checkbox last-checkbox" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checkbox.fssp,
                    expression: "checkbox.fssp",
                  },
                ],
                attrs: { type: "checkbox", id: "checkbox-fssp" },
                domProps: {
                  checked: Array.isArray(_vm.checkbox.fssp)
                    ? _vm._i(_vm.checkbox.fssp, null) > -1
                    : _vm.checkbox.fssp,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.checkbox.fssp,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.checkbox, "fssp", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.checkbox,
                            "fssp",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.checkbox, "fssp", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-group__header",
                  attrs: { for: "checkbox-fssp" },
                },
                [_vm._v("Реестр исполнительных производств ФССП России")]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "visitor-check-block name-container" }, [
        _c(
          "div",
          { staticClass: "form-group form-group_inline form-group_inline-x3" },
          [
            _c("div", { staticClass: "form-group__header" }, [
              _vm._v("Фамилия"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.inputs.last_name,
                  expression: "inputs.last_name",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "name-input",
              attrs: {
                placeholder: "Фамилия",
                type: "text",
                disabled:
                  !_vm.checkbox.fssp &&
                  !_vm.checkbox.rozisk &&
                  !_vm.checkbox.terrorists,
              },
              domProps: { value: _vm.inputs.last_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "last_name", $event.target.value.trim())
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group form-group_inline form-group_inline-x3" },
          [
            _c("div", { staticClass: "form-group__header" }, [_vm._v("Имя")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.inputs.first_name,
                  expression: "inputs.first_name",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "name-input",
              attrs: {
                placeholder: "Имя",
                type: "text",
                disabled:
                  !_vm.checkbox.fssp &&
                  !_vm.checkbox.rozisk &&
                  !_vm.checkbox.terrorists,
              },
              domProps: { value: _vm.inputs.first_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "first_name", $event.target.value.trim())
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "form-group form-group_inline form-group_inline-x3 fatherName-container",
          },
          [
            _c("div", { staticClass: "form-group__header" }, [
              _vm._v("Отчество"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.inputs.patronymic,
                  expression: "inputs.patronymic",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "name-input",
              attrs: {
                placeholder: "Отчество",
                type: "text",
                disabled:
                  !_vm.checkbox.fssp &&
                  !_vm.checkbox.rozisk &&
                  !_vm.checkbox.terrorists,
              },
              domProps: { value: _vm.inputs.patronymic },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.inputs, "patronymic", $event.target.value.trim())
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "date-passport__container" }, [
          _c("div", { staticClass: "date-passport__box" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "14px",
                  "margin-top": "15px",
                  "margin-bottom": "5px",
                  "font-weight": "400",
                },
              },
              [_vm._v("Дата рождения")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "date-passport__holder" }, [
              _c(
                "div",
                {
                  staticClass: "form-group date-part",
                  staticStyle: { "margin-top": "0" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs.day,
                        expression: "inputs.day",
                      },
                    ],
                    staticClass: "date-input",
                    staticStyle: { "margin-top": "0", width: "70px" },
                    attrs: {
                      placeholder: "День",
                      type: "text",
                      disabled:
                        !_vm.checkbox.fssp &&
                        !_vm.checkbox.rozisk &&
                        !_vm.checkbox.terrorists,
                    },
                    domProps: { value: _vm.inputs.day },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.inputs, "day", $event.target.value)
                        },
                        function ($event) {
                          _vm.inputs.day = $event.target.value
                            .replace(/[^0-9]/g, "")
                            .replace(/(^[0-9]{2})(.*)/, "$1")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs.month,
                        expression: "inputs.month",
                      },
                    ],
                    staticClass: "date-input",
                    staticStyle: { "margin-top": "0", width: "70px" },
                    attrs: {
                      placeholder: "Месяц",
                      type: "text",
                      disabled:
                        !_vm.checkbox.fssp &&
                        !_vm.checkbox.rozisk &&
                        !_vm.checkbox.terrorists,
                    },
                    domProps: { value: _vm.inputs.month },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.inputs, "month", $event.target.value)
                        },
                        function ($event) {
                          _vm.inputs.month = $event.target.value
                            .replace(/[^0-9]/g, "")
                            .replace(/(^[0-9]{2})(.*)/, "$1")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs.year,
                        expression: "inputs.year",
                      },
                    ],
                    staticClass: "date-input date-year",
                    staticStyle: { "margin-top": "0", width: "90px" },
                    attrs: {
                      placeholder: "Год",
                      type: "text",
                      disabled:
                        !_vm.checkbox.fssp &&
                        !_vm.checkbox.rozisk &&
                        !_vm.checkbox.terrorists,
                    },
                    domProps: { value: _vm.inputs.year },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.inputs, "year", $event.target.value)
                        },
                        function ($event) {
                          _vm.inputs.year = $event.target.value
                            .replace(/[^0-9]/g, "")
                            .replace(/(^[0-9]{4})(.*)/, "$1")
                        },
                      ],
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "date-passport__box" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "14px",
                  "margin-top": "15px",
                  "margin-bottom": "5px",
                  "font-weight": "400",
                },
              },
              [_vm._v("Серия и номер паспорта")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "date-passport__holder" }, [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  staticStyle: {
                    "margin-top": "0",
                    "margin-right": "0",
                    display: "flex",
                  },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs.passport_serial,
                        expression: "inputs.passport_serial",
                      },
                    ],
                    attrs: {
                      id: "seria",
                      placeholder: "Серия",
                      type: "text",
                      disabled: !_vm.checkbox.passports,
                    },
                    domProps: { value: _vm.inputs.passport_serial },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputs,
                            "passport_serial",
                            $event.target.value
                          )
                        },
                        function ($event) {
                          _vm.inputs.passport_serial = $event.target.value
                            .replace(/[^0-9]/g, "")
                            .replace(/(^[0-9]{4})(.*)/, "$1")
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs.passport_number,
                        expression: "inputs.passport_number",
                      },
                    ],
                    attrs: {
                      id: "number",
                      placeholder: "Номер",
                      type: "text",
                      disabled: !_vm.checkbox.passports,
                      required: "",
                    },
                    domProps: { value: _vm.inputs.passport_number },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.inputs,
                            "passport_number",
                            $event.target.value
                          )
                        },
                        function ($event) {
                          _vm.inputs.passport_number = $event.target.value
                            .replace(/[^0-9]/g, "")
                            .replace(/(^[0-9]{6})(.*)/, "$1")
                        },
                      ],
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fl-container" }, [
      _c("div", { staticClass: "form-group button-holder" }, [
        _c(
          "button",
          {
            staticClass: "form-group__button form-group__button_transparent",
            attrs: { value: "Поиск" },
            on: {
              click: function () {
                _vm.clearInputs()
              },
            },
          },
          [_vm._v("Очистить")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "form-group__button",
            class: { inactive: _vm.getInapproval() },
            staticStyle: { "line-height": "normal" },
            attrs: { disabled: _vm.getInapproval(), value: "Поиск" },
            on: {
              click: function () {
                _vm.searchHandle()
              },
            },
          },
          [
            _vm.loading
              ? _c("i", {
                  staticClass: "lnr lnr-sync rotating",
                  staticStyle: { "font-size": "18px", display: "inline-block" },
                  attrs: { title: "Загрузка" },
                })
              : _c("span", [_vm._v("Поиск")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "fl-container" }, [
      _vm.showResults
        ? _c("div", { ref: "result", staticClass: "fz16 result" }, [
            _c(
              "h2",
              {
                staticStyle: {
                  color: "#1e8bc3",
                  "font-weight": "500",
                  "font-size": "32px",
                },
              },
              [
                _vm.loading
                  ? _c("span", [
                      _c("i", {
                        staticClass: "lnr lnr-sync rotating",
                        staticStyle: {
                          "font-size": "22px",
                          "font-weight": "bold",
                          "margin-right": "4px",
                          display: "inline-block",
                        },
                        attrs: { title: "Загрузка" },
                      }),
                      _vm._v("Загрузка...\n                "),
                    ])
                  : _c("span", [_vm._v("Результат проверки")]),
              ]
            ),
            _vm._v(" "),
            _vm.result.passports != null
              ? _c("div", [
                  _vm.result.passports.passports == true
                    ? _c(
                        "p",
                        { staticStyle: { "font-size": "22px" } },
                        [
                          _c("IconClose"),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(
                              "Паспорт " +
                                _vm._s(_vm.result.passports.serial) +
                                " " +
                                _vm._s(_vm.result.passports.number) +
                                " входит в реестр недействительных"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm.result.passports.passports == false
                    ? _c(
                        "p",
                        { staticStyle: { "font-size": "22px" } },
                        [
                          _c("IconCheck"),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(
                              "Паспорт " +
                                _vm._s(_vm.result.passports.serial) +
                                " " +
                                _vm._s(_vm.result.passports.number) +
                                " отсутствует в реестре недействительных"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.result.terrorists != null
              ? _c("div", [
                  _vm.result.terrorists.terrorists.length
                    ? _c(
                        "div",
                        [
                          _c(
                            "p",
                            { staticStyle: { "font-size": "22px" } },
                            [
                              _c("IconClose"),
                              _vm._v(" "),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.result.terrorists.query_param.fio
                                  ) +
                                    " " +
                                    _vm._s(
                                      _vm.formatDateFromObject(
                                        _vm.result.terrorists.query_param.date
                                      )
                                    ) +
                                    " находится в реестре террористов/экстремистов:"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(
                            _vm.result.terrorists.terrorists,
                            function (e, i) {
                              return _c("p", { key: i }, [
                                _c(
                                  "b",
                                  { staticStyle: { "font-weight": "400" } },
                                  [
                                    _vm._v(
                                      _vm._s(e.fio ? e.fio + "," : "") +
                                        " " +
                                        _vm._s(e.bday ? e.bday + " гр," : "") +
                                        " " +
                                        _vm._s(e.address ? e.address : "")
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                        ],
                        2
                      )
                    : _c("div", [
                        _c(
                          "p",
                          { staticStyle: { "font-size": "22px" } },
                          [
                            _c("IconCheck"),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm.result.terrorists.query_param.fio) +
                                  " " +
                                  _vm._s(
                                    _vm.formatDateFromObject(
                                      _vm.result.terrorists.query_param.date
                                    )
                                  ) +
                                  " не находится в реестре террористов/экстремистов"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.result.rozisk != null
              ? _c("div", [
                  _vm.result.rozisk.find_obj.length
                    ? _c(
                        "div",
                        [
                          _c(
                            "p",
                            { staticStyle: { "font-size": "22px" } },
                            [
                              _c("IconClose"),
                              _vm._v(" "),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.result.rozisk.query_param.fio) +
                                    " " +
                                    _vm._s(
                                      _vm.formatDateFromObject(
                                        _vm.result.rozisk.query_param.date
                                      )
                                    ) +
                                    " находится в реестре Федерального Розыска:"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.result.rozisk.find_obj, function (e, i) {
                            return _c("div", { key: i }, [
                              _c("p", { staticStyle: { margin: "5px 0" } }, [
                                _c("img", {
                                  staticStyle: { width: "100px" },
                                  attrs: { src: e.url_img },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "400" } },
                                  [_vm._v(_vm._s(e.fio))]
                                ),
                              ]),
                            ])
                          }),
                        ],
                        2
                      )
                    : _c("div", [
                        _c(
                          "p",
                          { staticStyle: { "font-size": "22px" } },
                          [
                            _c("IconCheck"),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.result.rozisk.query_param.fio
                                    ? "" + _vm.result.rozisk.query_param.fio
                                    : ""
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.formatDateFromObject(
                                      _vm.result.rozisk.query_param.date
                                    )
                                  ) +
                                  " не находится в реестре Федерального Розыска"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.result.fssp != null
              ? _c("div", [
                  _vm.result.fssp.ip.result.length ||
                  _vm.result.fssp.rozysk_ip.result.length ||
                  _vm.result.fssp.rozysk_yk.result.length
                    ? _c(
                        "p",
                        { staticStyle: { "font-size": "22px" } },
                        [
                          _c("IconClose"),
                          _vm._v(" "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.result.fssp.query_param.fio) +
                                " " +
                                _vm._s(
                                  _vm.formatDateFromObject(
                                    _vm.result.fssp.query_param.date
                                  )
                                ) +
                                " находится в реестре ФССП"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.fssp.ip.result.length
                    ? _c(
                        "div",
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _vm._l(_vm.result.fssp.ip.result, function (e, i) {
                            return _c(
                              "div",
                              {
                                key: i,
                                staticStyle: {
                                  "font-size": "14px",
                                  margin: "10px 0",
                                },
                              },
                              [
                                _c("div", [
                                  e.ip_date
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "400" },
                                        },
                                        [_vm._v(_vm._s(e.ip_date))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  e.ip_number
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "18px" },
                                        },
                                        [_vm._v(_vm._s(e.ip_number))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  e.date_end
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "400" },
                                        },
                                        [_vm._v("окончено")]
                                      )
                                    : !e.date_end
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: { "font-weight": "400" },
                                        },
                                        [_vm._v("открыто")]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                e.ip_info
                                  ? _c("div", [
                                      _c("b", [_vm._v("Предмет исполнения:")]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(e.ip_info))]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                e.otdel_fssp
                                  ? _c("div", [
                                      _c("b", [_vm._v("Адрес отдела:")]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(e.otdel_fssp)),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.fssp.rozysk_ip.result.length
                    ? _c(
                        "div",
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _vm._l(
                            _vm.result.fssp.rozysk_ip.result,
                            function (e, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticStyle: {
                                    "font-size": "14px",
                                    margin: "10px 0",
                                  },
                                },
                                [
                                  _c("div", [
                                    e.ip_date
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "400",
                                            },
                                          },
                                          [_vm._v(_vm._s(e.ip_date))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    e.ip_number
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "18px",
                                            },
                                          },
                                          [_vm._v(_vm._s(e.ip_number))]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  e.delo_number
                                    ? _c("div", [
                                        _c("b", [_vm._v("Номер дела:")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(e.delo_number)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  e.otdel_fssp
                                    ? _c("div", [
                                        _c("b", [_vm._v("Адрес отдела:")]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(e.otdel_fssp)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.fssp.rozysk_yk.result.length
                    ? _c(
                        "div",
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _vm._l(
                            _vm.result.fssp.rozysk_yk.result,
                            function (e, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticStyle: {
                                    "font-size": "14px",
                                    margin: "10px 0",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("b", [_vm._v("Адрес проживания:")]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(e.address))]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v("Орган инициировавший розыск:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(e.name_org_initiating)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [
                                      _vm._v("Орган осуществляющий розыск:"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(e.name_org_initiates)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("b", [_vm._v("Статья:")]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(e.statya))]),
                                  ]),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.result.fssp.ip.result.length == 0 &&
                  _vm.result.fssp.rozysk_ip.result.length == 0 &&
                  _vm.result.fssp.rozysk_yk.result.length == 0
                    ? _c("div", [
                        _c(
                          "p",
                          { staticStyle: { "font-size": "22px" } },
                          [
                            _c("IconCheck"),
                            _vm._v(" "),
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.result.fssp.query_param.fio
                                    ? "" + _vm.result.fssp.query_param.fio
                                    : ""
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.formatDateFromObject(
                                      _vm.result.fssp.query_param.date
                                    )
                                  ) +
                                  " не находится в реестре ФССП"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showResults
        ? _c(
            "button",
            {
              staticClass: "form-group__button",
              staticStyle: { "margin-top": "10px" },
              on: { click: _vm.saveResultPDF },
            },
            [_vm._v("Скачать .pdf")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "fl-container container__history" },
      [
        _c(
          "h2",
          {
            staticStyle: {
              color: "#1e8bc3",
              "font-weight": "500",
              "font-size": "32px",
            },
          },
          [_vm._v("История проверок")]
        ),
        _vm._v(" "),
        _vm.admin
          ? _c("adminFilters", {
              attrs: {
                adminType: "check_visitor",
                onFilterCallback: _vm.getHistory,
              },
              on: {
                "admin-request": _vm.adminRequest,
                "history-refresh": _vm.historyRefresh,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("dropDownButton", {
          attrs: {
            title: "Скачать в .xlsx",
            items: ["Первые 5000 записей", "Текущую страницу"],
            onSelect: _vm.downloadXLSX,
          },
        }),
        _vm._v(" "),
        _vm.history.pagination && _vm.history.items.length
          ? _c("pagination", {
              attrs: {
                pagination: _vm.history.pagination,
                onTurnPageCallBack: _vm.getHistory,
                showRowsPerPageSelection: false,
                rows_on_page: _vm.history.items.length,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass: "content-table",
            staticStyle: {
              "font-size": "16px",
              "margin-top": "25px",
              width: "100%",
            },
          },
          [
            _c("tr", [
              _c("th", { attrs: { id: "date" } }, [_vm._v("Дата и время")]),
              _vm._v(" "),
              _vm.admin ? _c("th", [_vm._v("Пользователь")]) : _vm._e(),
              _vm._v(" "),
              _c("th", [_vm._v("Реестры")]),
              _vm._v(" "),
              _c("th", [_vm._v("Результат проверки")]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.history.items, function (e, i) {
              return _c(
                "tr",
                { key: i, staticStyle: { "font-size": "14px" } },
                [
                  _c("td", { attrs: { id: "time" } }, [
                    _vm._v(
                      _vm._s(
                        new Date(
                          e.query_param.date_of_visitor
                        ).toLocaleDateString()
                      ) +
                        " " +
                        _vm._s(
                          _vm.getHoursAndMinutesFomDateObjectString(
                            e.query_param.date_of_visitor
                          )
                        )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.admin
                    ? _c("td", [
                        _vm._v(_vm._s(e.user_name)),
                        _c("br"),
                        _vm._v(
                          _vm._s(e.user_login ? "(" + e.user_login + ")" : "")
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          Object.keys(e.check_result)
                            .join(", ")
                            .replace("terrorists", "Терр./Экстр.")
                            .replace("passports", "Паспорт")
                            .replace("fed_rozysk", "Фед. Розыск")
                            .replace("fssp_fl", "ФССП")
                        ) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function () {
                          _vm.modal_show = true
                          _vm.modal = {
                            check_result: e.check_result,
                            fio: e.query_param.fio,
                            date: e.query_param.date,
                            dateCheck: new Date(
                              e.query_param.date_of_visitor
                            ).toLocaleDateString(),
                          }
                        },
                      },
                    },
                    [
                      (e.check_result.terrorists &&
                        e.check_result.terrorists.length) ||
                      (e.check_result.passports &&
                        e.check_result.passports.result) ||
                      (e.check_result.fed_rozysk &&
                        e.check_result.fed_rozysk.length) ||
                      (e.check_result.fssp_fl &&
                        (e.check_result.fssp_fl.ip.result.length ||
                          e.check_result.fssp_fl.rozysk_ip.result.length ||
                          e.check_result.fssp_fl.rozysk_yk.result.length))
                        ? _c("IconClose")
                        : _c("IconCheck"),
                      _vm._v(" "),
                      e.check_result.passports &&
                      e.check_result.passports.serial &&
                      e.check_result.passports.number
                        ? _c("span", { staticStyle: { color: "#5F83F4" } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(e.check_result.passports.serial) +
                                " " +
                                _vm._s(e.check_result.passports.number) +
                                " \n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      e.query_param.fio
                        ? _c("span", { staticStyle: { color: "#5F83F4" } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(e.query_param.fio) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      e.query_param.date &&
                      Object.values(e.query_param.date).join("")
                        ? _c("span", { staticStyle: { color: "#5F83F4" } }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.formatDateFromObject(e.query_param.date)
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.history.pagination && _vm.history.items.length
          ? _c("pagination", {
              attrs: {
                pagination: _vm.history.pagination,
                onTurnPageCallBack: _vm.getHistory,
                showRowsPerPageSelection: false,
                rows_on_page: _vm.history.items.length,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.modal_show
          ? _c(
              "modal",
              {
                attrs: {
                  close: function () {
                    _vm.modal_show = false
                  },
                  printButton: true,
                  downloadButton: true,
                },
              },
              [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      color: "#1e8bc3",
                      "font-weight": "500",
                      "font-size": "25px",
                    },
                    attrs: { slot: "modalHeader" },
                    slot: "modalHeader",
                  },
                  [_vm._v("Результат проверки " + _vm._s(_vm.modal.dateCheck))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { padding: "15px" },
                    attrs: { slot: "modalBody" },
                    slot: "modalBody",
                  },
                  [
                    _vm.modal.check_result.passports != null
                      ? _c("div", { attrs: { stlye: "margin: 0 0 15px;" } }, [
                          _vm.modal.check_result.passports.result == true
                            ? _c(
                                "p",
                                { staticStyle: { "font-size": "22px" } },
                                [
                                  _c("IconClose"),
                                  _vm._v(" "),
                                  _c("b", [
                                    _vm._v(
                                      "Паспорт " +
                                        _vm._s(
                                          _vm.modal.check_result.passports
                                            .serial
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.modal.check_result.passports
                                            .number
                                        ) +
                                        " входит в реестр недействительных"
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm.modal.check_result.passports.result == false
                            ? _c(
                                "p",
                                { staticStyle: { "font-size": "22px" } },
                                [
                                  _c("IconCheck"),
                                  _vm._v(" "),
                                  _c("b", [
                                    _vm._v(
                                      "Паспорт " +
                                        _vm._s(
                                          _vm.modal.check_result.passports
                                            .serial
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.modal.check_result.passports
                                            .number
                                        ) +
                                        " отсутствует в реестре недействительных"
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modal.check_result.terrorists != null
                      ? _c("div", { staticStyle: { margin: "0 0 15px" } }, [
                          _vm.modal.check_result.terrorists.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "22px",
                                        margin: "0",
                                      },
                                    },
                                    [
                                      _c("IconClose"),
                                      _vm._v(" "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.modal.fio) +
                                            " " +
                                            _vm._s(
                                              _vm.formatDateFromObject(
                                                _vm.modal.date
                                              )
                                            ) +
                                            " находится в реестре террористов/экстремистов:"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.modal.check_result.terrorists,
                                    function (e, i) {
                                      return _c(
                                        "p",
                                        {
                                          key: i,
                                          staticStyle: {
                                            "font-weight": "500",
                                            margin: "0",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "400",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  e.fio ? e.fio + "," : ""
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    e.bday
                                                      ? e.bday + " гр,"
                                                      : ""
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    e.address ? e.address : ""
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _c("div", [
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "22px" } },
                                  [
                                    _c("IconCheck"),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.modal.fio) +
                                          " " +
                                          _vm._s(
                                            _vm.formatDateFromObject(
                                              _vm.modal.date
                                            )
                                          ) +
                                          " не находится в реестре террористов/экстремистов"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modal.check_result.fed_rozysk != null
                      ? _c("div", [
                          _vm.modal.check_result.fed_rozysk.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "p",
                                    { staticStyle: { "font-size": "22px" } },
                                    [
                                      _c("IconClose"),
                                      _vm._v(" "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.modal.fio) +
                                            " " +
                                            _vm._s(
                                              _vm.formatDateFromObject(
                                                _vm.modal.date
                                              )
                                            ) +
                                            " находится в реестре Федерального Розыска:"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.modal.check_result.fed_rozysk,
                                    function (e, i) {
                                      return _c("div", { key: i }, [
                                        _c(
                                          "p",
                                          { staticStyle: { margin: "5px 0" } },
                                          [
                                            _c("img", {
                                              staticStyle: { width: "100px" },
                                              attrs: { src: e.url_img },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-weight": "400",
                                                },
                                              },
                                              [_vm._v(_vm._s(e.fio))]
                                            ),
                                          ]
                                        ),
                                      ])
                                    }
                                  ),
                                ],
                                2
                              )
                            : _c("div", [
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "22px" } },
                                  [
                                    _c("IconCheck"),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.modal.fio) +
                                          " " +
                                          _vm._s(
                                            _vm.formatDateFromObject(
                                              _vm.modal.date
                                            )
                                          ) +
                                          " не находится в реестре Федерального Розыска"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modal.check_result.fssp_fl != null
                      ? _c("div", [
                          _vm.modal.check_result.fssp_fl.ip.result.length ||
                          _vm.modal.check_result.fssp_fl.rozysk_ip.result
                            .length ||
                          _vm.modal.check_result.fssp_fl.rozysk_yk.result.length
                            ? _c(
                                "p",
                                { staticStyle: { "font-size": "22px" } },
                                [
                                  _c("IconClose"),
                                  _vm._v(" "),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.modal.fio) +
                                        " " +
                                        _vm._s(
                                          _vm.formatDateFromObject(
                                            _vm.modal.date
                                          )
                                        ) +
                                        " находится в реестре ФССП"
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modal.check_result.fssp_fl.ip.result.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c("b", [
                                        _vm._v("Исполнительные производства"),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.modal.check_result.fssp_fl.ip.result,
                                    function (e, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticStyle: {
                                            "font-size": "14px",
                                            margin: "10px 0",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            e.ip_date
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "400",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(e.ip_date))]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            e.ip_number
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(e.ip_number))]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            e.date_end
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "400",
                                                    },
                                                  },
                                                  [_vm._v("окончено")]
                                                )
                                              : !e.date_end
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "400",
                                                    },
                                                  },
                                                  [_vm._v("открыто")]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          e.ip_info
                                            ? _c("div", [
                                                _c("b", [
                                                  _vm._v("Предмет исполнения:"),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(e.ip_info)),
                                                ]),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          e.otdel_fssp
                                            ? _c("div", [
                                                _c("b", [
                                                  _vm._v("Адрес отдела:"),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(e.otdel_fssp)),
                                                ]),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modal.check_result.fssp_fl.rozysk_ip.result.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          "Розыск по исполнительным производствам"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.modal.check_result.fssp_fl.rozysk_ip
                                      .result,
                                    function (e, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticStyle: {
                                            "font-size": "14px",
                                            margin: "10px 0",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            e.ip_date
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "400",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(e.ip_date))]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            e.ip_number
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "18px",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(e.ip_number))]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          e.delo_number
                                            ? _c("div", [
                                                _c("b", [
                                                  _vm._v("Номер дела:"),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(e.delo_number)),
                                                ]),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          e.otdel_fssp
                                            ? _c("div", [
                                                _c("b", [
                                                  _vm._v("Адрес отдела:"),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(e.otdel_fssp)),
                                                ]),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modal.check_result.fssp_fl.rozysk_yk.result.length
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "18px",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          "Подозрение в совершении преступлений"
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.modal.check_result.fssp_fl.rozysk_yk
                                      .result,
                                    function (e, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticStyle: {
                                            "font-size": "14px",
                                            margin: "10px 0",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("b", [
                                              _vm._v("Адрес проживания:"),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(e.address)),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("b", [
                                              _vm._v(
                                                "Орган инициировавший розыск:"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(e.name_org_initiating)
                                              ),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("b", [
                                              _vm._v(
                                                "Орган осуществляющий розыск:"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(e.name_org_initiates)
                                              ),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("b", [_vm._v("Статья:")]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(e.statya)),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modal.check_result.fssp_fl.ip.result.length ==
                            0 &&
                          _vm.modal.check_result.fssp_fl.rozysk_ip.result
                            .length == 0 &&
                          _vm.modal.check_result.fssp_fl.rozysk_yk.result
                            .length == 0
                            ? _c("div", [
                                _c(
                                  "p",
                                  { staticStyle: { "font-size": "22px" } },
                                  [
                                    _c("IconCheck"),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.modal.fio
                                            ? "" + _vm.modal.fio
                                            : ""
                                        ) +
                                          " " +
                                          _vm._s(
                                            _vm.formatDateFromObject(
                                              _vm.modal.date
                                            )
                                          ) +
                                          " не находится в реестре ФССП"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticStyle: { "list-style-type": "disc", width: "100%" } },
      [
        _c("li", [_vm._v("проверка посетителей")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("первичная проверка заявителей на предоставление услуг"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "font-size": "18px", "margin-top": "10px" } },
      [_c("b", [_vm._v("Исполнительные производства")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "font-size": "18px", "margin-top": "10px" } },
      [_c("b", [_vm._v("Розыск по исполнительным производствам")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "font-size": "18px", "margin-top": "10px" } },
      [_c("b", [_vm._v("Подозрение в совершении преступлений")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }